var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrientationAny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 2L2 5.6a.848.848 0 0 0 0 1.2L9.2 14a.849.849 0 0 0 1.2 0l3.6-3.6a.849.849 0 0 0 0-1.2L6.8 2a.849.849 0 0 0-1.2 0zM1.4 5a1.697 1.697 0 0 0 0 2.4l7.2 7.2a1.697 1.697 0 0 0 2.4 0l3.6-3.6a1.697 1.697 0 0 0 0-2.4L7.4 1.4a1.697 1.697 0 0 0-2.4 0L1.4 5z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 0.849,
    transform: "rotate(45 11 11)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6c0-.976-.268-2.355-1-3-.96-.846-2.024-1-3-1m4 4l1-1m-1 1l-1-1M2.002 9.998c0 .976.268 2.354 1 3 .96.846 2.024 1 3 1m-4-4l-1 1m1-1l1 1",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientationAny);
export default __webpack_public_path__ + "static/media/orientation-any.1d9dc4eaf7b65c05f833d96ccd73173f.svg";
export { ForwardRef as ReactComponent };